/**
 * オーバーレイ・リッチエディタを適用します。
 * @requires jQuery, mtappVars
 */
// @ts-ignore
const tinymce = window.tinymce;
// @ts-ignore
const MTRichTextEditor = window.MTRichTextEditor;
// @ts-ignore
const app = window.app;
// @ts-ignore
const bootstrap = window.bootstrap;
// @ts-ignore
const jQuery = window.jQuery;
// @ts-ignore
const MT = window.MT;
// @ts-ignore
const mtappVars = window.mtappVars;

export const overlayEditor = {
    textareaId: 'mtapp-overlay-editor',
    textarea: null,
    modalId: 'mtapp-overlay-editor-modal',
    modal: null,
    getSourceModeButton() {
        let sourceButton = jQuery(`#${this.modalId} [aria-label="mt_source_mode"]`);
        if (!sourceButton.length) {
            sourceButton = jQuery(`#${this.modalId} [aria-label="HTML編集モードの切り替え"]`);
        }
        if (!sourceButton.length) {
            sourceButton = jQuery(`#${this.modalId} [aria-label="Toggle HTML Edit Mode"]`);
        }
        return sourceButton;
    },
    init() {
        // オーバーレイ・リッチエディタのデータが保存される textarea を取得
        this.textarea = document.getElementById(this.textareaId);

        this.modal = new bootstrap.Modal(`#${this.modalId}`, {
            backdrop: true,
            keyboard: false,
            focus: true
        });

        jQuery(`#${this.modalId}`).on({
            'hidden.bs.modal': function () {
                // 既存のエディタを削除
                if (app && app.editors && app.editors['mtapp-overlay-editor']) {
                    try {
                        // MTRichTextEditorの場合はunloadを使用
                        if (typeof MTRichTextEditor !== 'undefined' && MTRichTextEditor.get({ id: 'mtapp-overlay-editor' })) {
                            MTRichTextEditor.unload({ id: 'mtapp-overlay-editor' });
                        }
                        // TinyMCEの場合はremoveを使用
                        else if (tinymce && tinymce.get('mtapp-overlay-editor')) {
                            tinymce.remove('#mtapp-overlay-editor');
                        }
                    } catch (error) {
                        console.warn('Error removing editor on modal close:', error);
                    }
                    delete app.editors['mtapp-overlay-editor'];
                }

                jQuery('#mtapp-overlay-editor').prependTo('#mtapp-overlay-editor-inner').nextAll().remove();
                jQuery('body').off('focusin.overlayEditor focusout.overlayEditor');
            },
            'shown.bs.modal': function () {
                jQuery('.modal-backdrop.show:last').css('z-index', 1030);
                // PROD_MTAPPJQUERY-122 オーバーレイ・リッチテキストのリンクやHTML挿入が入力できない
                // jQuery(document).off('focusin.bs.modal'); // 利用しない

                // Issue #465
                // jquery.mt.js で定義されている下記のイベントを止める
                // ```
                // $(document).on('focusin focusout','input:not([type=radio]):not(.group), textarea',function () {
                //     var ns = $.data( this, 'mtValidator' );
                //     if ( !ns ) return true;
                //     $(this).mtValid({ focus: false });
                // });
                // ```
                jQuery('body').on(
                    'focusin.overlayEditor focusout.overlayEditor',
                    'input:not([type=radio]):not(.group), textarea',
                    function () {
                        this.addEventListener(
                            'focusin',
                            function (e) {
                                e.stopPropagation();
                            },
                            false
                        );
                    }
                );
            }
        });
        jQuery(`#${this.modalId} .modal-dialog`).css({
            width: (window.innerWidth / 3) * 2,
            maxWidth: (window.innerWidth / 3) * 2
        });
    },
    open(id, html) {
        html = typeof html === 'undefined' ? '' : html;
        if (typeof id === 'string') {
            this.textarea.value = html;
            document.getElementById(this.modalId).setAttribute('data-target-id', id);
            this.modal.show();
            if (typeof app.editors === 'undefined') {
                app.editors = {};
            }

            // 既存のエディタがあれば削除
            if (app.editors[this.textareaId]) {
                try {
                    // MTRichTextEditorの場合はunloadを使用
                    if (typeof MTRichTextEditor !== 'undefined' && MTRichTextEditor.get({ id: this.textareaId })) {
                        MTRichTextEditor.unload({ id: this.textareaId });
                    }
                    // TinyMCEの場合はremoveを使用
                    else if (tinymce && tinymce.get(this.textareaId)) {
                        tinymce.remove(this.textareaId);
                    }
                } catch (error) {
                    console.warn('Error removing existing editor:', error);
                }
                delete app.editors[this.textareaId];
            }

            // 新しいエディタを作成
            app.editors[this.textareaId] = new MT.EditorManager(this.textareaId, {
                format: 'richtext',
                wrap: true
            });

            // HTMLモードをクリックした時に値を保存する
            const self = this;
            jQuery(`#${this.modalId} [aria-label="mt_source_mode"]`).on('click', function () {
                if (app && app.editors && app.editors[self.textareaId]) {
                    app.editors[self.textareaId].currentEditor.save();
                }
            });
        }
    },
    save() {
        const sourceModeButton = this.getSourceModeButton();
        if (sourceModeButton.length && sourceModeButton.is('[aria-pressed="true"]')) {
            sourceModeButton.trigger('click');
        }
        if (app && app.editors && app.editors[this.textareaId]) {
            app.editors[this.textareaId].currentEditor.save();
        }
        const html = this.textarea.value;
        const id = jQuery(`#${this.modalId}`).modal('hide').attr('data-target-id');
        const target = document.getElementById(id);
        target.value = html;
        target.dispatchEvent(mtappVars.eventInput);
        document.getElementById(id + '-view').innerHTML = html;
    },
    cancel() {
        const sourceModeButton = this.getSourceModeButton();
        if (sourceModeButton.length && sourceModeButton.is('[aria-pressed="true"]')) {
            sourceModeButton.trigger('click');
        }
        jQuery(`#${this.modalId}`).modal('hide');
    }
};
